import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import TextBox from 'devextreme-react/text-box'
import Validator from 'devextreme-react/validator'
import { CustomRule, RequiredRule } from 'devextreme-react/form'
import Button from 'devextreme-react/button'
import { useMediaQuery } from '@react-hooks-library/core'
import TextArea from 'devextreme-react/text-area'

const btnStyle = { backgroundColor: '#40c0c0' }

const TextBoxField = ({ submit, question }) => {
  const required = question.es_obligatoria
  const maxWords = question.tamanio_palabras
  const defaultValue = question.respuesta_texto
  const isLarge = question.es_texto_largo

  const isLargeScreen = useMediaQuery('(min-width: 640px)')
  const [value, setValue] = useState(defaultValue)
  const textBoxRef = useRef(null)
  const buttonRef = useRef(null)

  const submitCallback = useCallback(() => submit(textBoxRef.current.instance.option('value')), [submit, textBoxRef])

  const validateCallback = useCallback(({ isValid }) => {
    const btn = buttonRef.current.instance
    const btnElement = btn.element()
    if (isValid) {
      btnElement.classList.remove('mt-8')
    } else {
      btnElement.classList.add('mt-8')
    }
  }, [buttonRef])

  const validationCallback = useCallback(({ value }) => value?.split(' ').length <= maxWords, [maxWords])
  const validations = useMemo(() => (
    <Validator onValidated={validateCallback}>
      {required ? <RequiredRule message='Este campo es requerido' /> : undefined}
      {maxWords ? <CustomRule message={'Solo se permiten ' + maxWords + ' palabras.'} validationCallback={validationCallback} /> : undefined}
    </Validator>
  ), [maxWords, required, validateCallback, validationCallback])

  useEffect(() => {
    const textBox = textBoxRef.current.instance

    setTimeout(() => {
      textBox.focus()
    }, 250)
  }, [textBoxRef, defaultValue])

  return (

    <>

      {maxWords > 0 && (<span className='text-gray-500 text-sm'>Solo se permiten {maxWords} palabras. {value?.split(' ').length ?? 0}/{maxWords}</span>)}

      {
        isLarge
          ? (<TextArea ref={textBoxRef} placeholder='Escribe aqui tu respuesta...' height={140} validationMessageMode='always' value={value} onValueChange={setValue}>{validations}</TextArea>)
          : (<TextBox ref={textBoxRef} placeholder='Escribe aqui tu respuesta...' validationMessageMode='always' onEnterKey={submitCallback} value={value} onValueChange={setValue}>{validations}</TextBox>)
      }

      <Button ref={buttonRef} width={isLargeScreen ? 138 : '100%'} className='mt-5' icon='arrowright' type='success' style={btnStyle} text='Continuar' onClick={submitCallback} />
    </>

  )
}

TextBoxField.propTypes = {
  submit: PropTypes.func.isRequired,
  question: PropTypes.object.isRequired
}

export default TextBoxField
